import { Common, color } from '@stockbit/ui';
import styled from 'styled-components';

const { Button } = Common;

export const VirtualTradingButtonContainer = styled(Button).attrs((props) => ({
  justify: props.justify || 'center',
}))`
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid ${color.downgray};
  justify-content: ${({ justify }) => justify};
`;
